var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalLinkFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "currentColor",
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.378 6.967h-1.514V3.469L7.938 19.43l-1.07-1.073L22.662 2.525H19.3V1h6.08v5.967Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.378 25h20.997V9.884H20.86v13.598H2.893V5.455h13.509V3.937H1.378V25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.378 6.967h-1.514V3.469L7.938 19.43l-1.07-1.073L22.662 2.525H19.3V1h6.08v5.967Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.378 25h20.997V9.884H20.86v13.598H2.893V5.455h13.509V3.937H1.378V25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalLinkFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ExternalLinkFilled.01acc31d5428ea7f75f08219bdf82565.svg";